import Service from "../../AuthService";

const TaxInvoice = {
    getTaxInvoice(page) {
        return Service.get("/tax_invoice?page="+page);
    },
    showTaxInvoice(id) {
        return Service.get("/tax_invoice/" + id);
    },
    updateTaxInvoice(id, data) {
        return Service.put("/tax_invoice/" + id, data);
    },
    createTaxInvoice(data, user) {
        return Service.post("/tax_invoice?user="+user, data);
    },
    deleteTaxInvoice(id) {
        return Service.delete("/tax_invoice/" + id);
    },
    searchTaxInvoice(page,data){
        return Service.post('/tax_invoice_search?page='+page,data);
    },
    selectTaxInvoiceAll(){
        return Service.get('/selectTaxInvoiceAll');
    },
    getInvoiceByStatusTax(){
        return Service.get('/get_invoice_by_status_tax');
    },
    printMultipleTax(id){
        return Service.get('/merge/tax_merge_pdf?id='+id);
    },
    getTaxList(){
        return Service.get('/get_tax_list');
    },
    getCustomerTaxList(){
        return Service.get('/get_customer_tax_list');
    },
    createTaxCustomer(data){
        return Service.post('/tax_customer_create',data);
    },
    showTaxCustomer(id){
        return Service.get('/show_customer_info?id='+id);
    },
    showTaxList(data){
        return Service.get('/show_tax_list?id='+data.id+'&customer_id='+data.customer_id+'&order='+data.order+'&time='+data.time);
    },
    saveTaxCustomer(data){
        return Service.post('/tax_customer_save',data);
    },
    getTaxCustomer(data){
        return Service.get(`/tax_customer?page=${data.page}&date_start=${data.date_start}&date_end=${data.date_end}&type=${data.search.type?data.search.type.value:''}&tax=${data.search.tax}`);
    },
    getTaxCustomerInfo(data){
        return Service.get(`/tax_customer_info?page=${data.page}&tax=${data.tax}`);
    },
    closeTaxInvoice(date){
        return Service.get(`/close_tax_invoice?date=${date}`);
    },
    chageAddressTaxInvoice(data){
        return Service.get(`/tax-invoice-pdf-new?id=${data.tax_address_id}&new=${data.tax_address}&customer_id=${data.tax_customer_id}`);
    },
};

export default TaxInvoice
